.picker {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.filters {
  overflow-x: auto;
  scrollbar-width: none;
  margin: 0 calc(-1 * var(--space-1));
  padding: 0 var(--space-1);
}

.filters::-webkit-scrollbar {
  display: none;
}

/* Geen eigen scroll meer (6 okt 2026): Alles toont per groep een deel, "+n meer" opent de groep. */
.scroll {
  padding: 2px;
}

.group + .group {
  margin-top: var(--space-3);
}

.groupTitle {
  margin: 0 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: 600;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(76px, 1fr));
  gap: var(--space-2);
}

.tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  min-height: 84px;
  padding: 8px 4px 8px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  cursor: pointer;
  transition: background-color var(--dur) var(--ease-out);
}

.tile:hover {
  background: var(--surface-hover);
}

.tile:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 1px;
}

.tile img,
.tile [data-picto-set] {
  display: block;
}

/* Namen over hooguit twee regels ("Tanden poetsen", "Planten water geven"), niet afgekapt. */
.tileLabel {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-width: 100%;
  overflow: hidden;
  font-size: var(--b-text-meta);
  line-height: 1.2;
  text-align: center;
  overflow-wrap: break-word;
  hyphens: auto;
}

/* "+n meer" als laatste tegel van een groep: tekst in het accent, midden in de tegel. */
.moreTile {
  justify-content: center;
  color: var(--accent);
  font-size: var(--b-text-small);
  font-weight: 600;
}

.selected {
  background: var(--accent-tint);
  color: var(--text);
  box-shadow: inset 0 0 0 2px var(--accent);
}

.none {
  width: 84px;
  margin-bottom: var(--space-3);
}

.noneMark {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px dashed var(--border-strong);
}

.empty {
  margin: var(--space-3) 0;
  color: var(--text-muted);
}

/* 0024 (docs/DESIGN.md §8.P.5): verborgen pictogrammen. Alleen de illustratie gedimd (.55), het
   label houdt de volle tekstkleur (WCAG 2.2 AA); geen doorhaling. */
.dim img,
.dim [data-picto-set] {
  opacity: 0.55;
}

.dim .tileLabel {
  color: var(--text);
}

.hiddenBlock {
  margin-top: var(--space-3);
}

.hiddenRow {
  margin: 0 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.linkButton {
  min-height: 44px;
  padding: 0 var(--space-1);
  border: 0;
  background: transparent;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.linkButton:focus-visible,
.change:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 1px;
}

.hiddenHead {
  margin: 0 0 var(--space-2);
  color: var(--text);
  font-size: var(--text-sm);
  font-weight: 600;
}

.change {
  color: var(--accent);
  font-weight: 600;
}

.reasonList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.reasonRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.reasonRow .tile {
  flex: 0 0 84px;
}

.reason {
  color: var(--text);
  font-size: var(--text-sm);
}
